<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from './Base.vue';
import ActionCard from './ActionCard.vue';
import { useMessageContext } from '../provider.js';

const { content, contentAttributes } = useMessageContext();
const { t } = useI18n();

const payment = computed(() => contentAttributes.value?.payment ?? {});
const amount = computed(() => String(payment.value.amount || '').trim());
const description = computed(() =>
  String(payment.value.description || '').trim()
);
const title = computed(
  () =>
    String(content.value || '').trim() ||
    t('CONVERSATION.REPLYBOX.USER_ACTIONS.PAYMENT_DEFAULT')
);
const link = computed(() => String(payment.value.link || '').trim());
const href = computed(() => {
  if (!link.value) return '';
  return /^https?:\/\//i.test(link.value)
    ? link.value
    : `https://${link.value}`;
});
</script>

<template>
  <BaseBubble
    class="w-72 max-w-full !bg-n-slate-3 px-3.5 py-3"
    data-bubble-name="payment"
  >
    <ActionCard
      kind="pay"
      :title="title"
      :subtitle="description"
      :pay-amount="amount"
      :pay-href="href"
    />
  </BaseBubble>
</template>
